import React from 'react';
import { PercentView } from '../PercentView';
import { MoneyView } from '../MoneyView';
import { InstrumentCommission } from '../../types/instrument';

interface Props {
  commission: InstrumentCommission;
}

export const Commission: React.FC<Props> = ({ commission }) => (
  <>
    {commission.__typename === 'ClearingWithdrawPercentFee' && (
      <PercentView>{commission.percent}</PercentView>
    )}
    {commission.__typename === 'ClearingWithdrawFixedFee' && (
      <MoneyView rule="0">{commission.amount}</MoneyView>
    )}
  </>
);
